<template>
	<div>
		<template v-if="islist">
			<el-popover ref="popover" placement="bottom" title="" width="300" trigger="click">
				<div style="box-sizing: border-box;padding: 0px 6px;">
					<el-divider>范围</el-divider>
					<el-form ref="form" :model="form" label-width="40px" size="mini">
						<el-row>
							<el-col :span="12">
								<el-form-item label="最小">
									<el-input-number controls-position="right" :size="size" v-model="form.min"
										placeholder="最小值" @change="formChange">
									</el-input-number>
								</el-form-item>
							</el-col>

							<el-col :span="12">
								<el-form-item label="最大">
									<el-input-number controls-position="right" :size="size" v-model="form.max"
										placeholder="最大值" @change="formChange">
									</el-input-number>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label-width="0px">
							<el-checkbox v-model="form.ismod" @change="formChange">绝对值</el-checkbox>
						</el-form-item>
						<el-form-item>
							<!-- <el-button type="primary" @click="onSubmit" style="float: right;">确认</el-button> -->
							<el-button style="float: right;" @click="formClear">清空</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-input slot="reference" :size="size" :value="value" @change="change"></el-input>
			</el-popover>
		</template>
		<template v-else>
			<template v-if="!renderCell">
				<el-input-number v-if="!config.disabled && !config.readonly" :readonly="config.readonly"
					:disabled="config.disabled" class="inputnumber" v-model="number" :min="config.min" :max="config.max"
					:size="size" :step="step" :precision="precision" @change="change"
					:controls-position="controlsPosition" cla></el-input-number>
				<el-input v-else :size="size" :value="number" :readonly="config.readonly" :disabled="config.disabled">
				</el-input>
			</template>
			<template v-else>
				<span>{{number}}</span>
			</template>
		</template>
	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	import {
		isNumber
	} from 'xe-utils'
	export default {
		mixins: [selectBase],
		props: {

		},
		data() {
			return {
				number: isNaN(parseFloat(this.value)) ? null : parseFloat(this.value),
				form: {
					min: null,
					max: null,
					ismod: false,
				},
				config: {
					// min: -Infinity,
					// max: Infinity,
					min: this.min,
					max: this.max,
					disabled: this.disabled,
					readonly: this.readonly,
				}
			}
		},
		created() {
			// this.setNumber()

		},
		mounted() {

			if (!this.renderCell && !this.islist) {
				this.initConfig()
			}
			// this.$nextTick(() => {
			// 	if (this.readonly) {

			// 		this.forbiddenButton()

			// 	}
			// })
			//console.log(this.config,123)
		},
		watch: {
			number(e) {
				if(this.formCreateInject){
					this.change(e)		
				}
						
			},
			value(e) {

				//console.log('watchchange:'+e)
				if (!e) {
					this.form.min = null
					this.form.max = null
					this.form.ismod = false
				}
				if (e === null) {
					// this.config.min = -Infinity
					// this.config.max = Infinity
					this.config.min = this.min
					this.config.max = this.max

				}
				this.number = e
				// this.setNumber()


				//this.change(e)
			}
		},
		computed: {
			// suffix() {
			// 	if (this.readonly) {
			// 		return 'vxe-icon-eye-fill'
			// 	}
			// 	if (this.disabled) {
			// 		return 'vxe-icon-lock-fill'
			// 	}
			// 	return 'vxe-icon-edit'
			// }
		},
		methods: {

			initConfig() {
				if (this.row && this.column) {
					if (!Object.hasOwn(this.row, this.column.field + '_canedit') || this.row[this.column.field +
							'_canedit'] === 1) {
						this.config.readonly = false
					} else {
						this.config.readonly = true
					}
					if (isNumber(this.row[this.column.field + '_min'])) {
						this.config.min = this.row[this.column.field + '_min']
					} else {
						//this.config.min = -Infinity
						this.config.min = this.min
					}
					if (isNumber(this.row[this.column.field + '_max'])) {
						this.config.max = this.row[this.column.field + '_max']
					} else {
						// this.config.max = Infinity
						this.config.max = this.max
					}
				}
			},
			// setNumber(){
			// 	this.number = this.value
			// 	if (this.row) {
			// 		if (this.row[this.column.field]) {
			// 			this.number = this.row[this.column.field]
			// 		} else {
			// 			this.number = isNaN(parseFloat(this.value)) ? 0 : parseFloat(this.value)
			// 		}
			// 	}
			// },
			onSubmit() {

			},
			formChange() {
				//console.log(this.form)
				let value = ''
				if (this.form.min || this.form.max) {
					if (this.form.min && this.form.max) {
						if (parseFloat(this.form.min) > parseFloat(this.form.max)) {
							value = '大于' + (this.form.ismod ? this.createmod(this.form.min) : this.form.min)
						} else if (parseFloat(this.form.min) < parseFloat(this.form.max)) {
							value = '大于' + (this.form.ismod ? this.createmod(this.form.min) : this.form.min) + '【并且】小于' + (
								this.form.ismod ? this.createmod(this.form.max) : this.form.max)
						} else {
							value = '等于' + this.form.min
						}
					} else if (!this.form.min) {
						value = '小于' + (this.form.ismod ? this.createmod(this.form.max) : this.form.max)
					} else {
						value = '大于' + (this.form.ismod ? this.createmod(this.form.min) : this.form.min)
					}
				}
				//console.log(value,this.form,444)
				this.change(value)
			},
			createmod(num) {
				return '|' + num + '|'
			},
			formClear() {
				this.form.min = null
				this.form.max = null
				this.formChange()
			},
			change(val) {
				if(val === null || val === undefined){
					return
				}
				let value = Object.hasOwn(val, 'value') ? val.value : val
				if (this.islist) {
					this.$emit('input', value)
					this.$emit('change', value)
				} else {
					value = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
					//console.log(value.toFixed(this.precision),123)
					this.$emit('input', value.toFixed(this.precision))
					this.$emit('change', value.toFixed(this.precision))
				}
			},
			// forbiddenButton() {
			// 	this.$el.childNodes.forEach((item) => {
			// 		if (item.nodeName === 'SPAN') {
			// 			item.style.pointerEvents = 'none'
			// 			item.style.display = 'none'
			// 		}
			// 	})
			// 	this.$refs.input.$refs.input.setAttribute('readonly', true)
			// },
		},

	}
</script>
<style scope>
	.inputnumber .el-input__inner {
		text-align: left;
	}
</style>